import { ProductType } from "@/common/constant/ProductType";
import { formatMinutesLowerCase } from "@/common/helpers/DateTimeHelper.js";
import { getFormattedNumber } from "@/common/helpers/PriceHelper.js";

/**
 * Note: Only service need to display processing time(minutes),
 * others product type no need to display even when processing time is 0
 */
const formatProcessingTime = (productType, processingTime, defaultValue = '') => {
  return productType === ProductType.SERVICE ?
    formatMinutesLowerCase(processingTime) : defaultValue;
};

const getItemLine = (type, productData) => {
  let itemLine = null;

  switch (type) {
    case ProductType.SERVICE:
      itemLine = productData.service;
      break;
    case ProductType.RETAIL_PRODUCT:
      itemLine = productData.retailProduct;
      break;
    case ProductType.COUPON:
      itemLine = productData.coupon;
      break;
    default:
      itemLine = null;
      break;
  }

  return itemLine;
};

const getPromotionHeader = (productData) => {
  const productType = productData.type;
  let itemLine = getItemLine(productType, productData);

  let percentageOff = '';
  let promotionDateRange = `${itemLine.startDate} - ${itemLine.endDate}`;
  if (productData.promotion) { // active promotion(current promotion)
    percentageOff = productData.originalPrice != 0 ?
      (1-(productData.salePrice / productData.originalPrice)) * 100 :
      0;
  } else if (productData.futurePromotion) { // future promotion
    percentageOff = productData.futureOriginalPrice > 0 ?
      (1-(productData.futureSalePrice / productData.futureOriginalPrice)) * 100 :
      0;
  } else { // not valid promotion
    promotionDateRange = '';
  }

  const percentageOffPerfix = percentageOff > 0 ? '-' : '';
  const percentageOffFormatted = getFormattedNumber(Math.abs(percentageOff), '.00', true);

  return `${percentageOffPerfix}${percentageOffFormatted} | ${promotionDateRange}`;
};

const getPromotionHeaderAlt = (product) => {
  let percentageOff = '';
  let promotionDateRange = `${product.promotionStartDate} - ${product.promotionEndDate}`;
  if (product.promotion) { // active promotion(current promotion)
    percentageOff = product.originalPrice > 0 ?
      (1-(product.salePrice / product.originalPrice)) * 100 :
      0;
  } else { // not valid promotion
    promotionDateRange = '';
  }

  const percentageOffPerfix = percentageOff > 0 ? '-' : '';
  const percentageOffFormatted = getFormattedNumber(Math.abs(percentageOff), '.00', true);

  return `${percentageOffPerfix}${percentageOffFormatted} | ${promotionDateRange}`;
};

export {
  formatProcessingTime,
  getItemLine,
  getPromotionHeader,
  getPromotionHeaderAlt,
};